// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"wk-z","innerTile":"xk-z","heading":"yk-z","instaTileBtn":"zk-z","disabled":"Ak-z","instaTileElement":"Bk-z","instagramPic":"Ck-z"};